<div class="h-full bg-white overflow-hidden relative">
  <div class="h-full overflow-y-auto">
    <div class="flex items-center pt-5 px-7 gap-2">
      <span class="material-icons text-[var(--primary-dark)] text-[20px]">article</span>
      <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Season Manager</span>
    </div>

    <div class="flex gap-0 px-7 border-b border-[var(--app-base)] mt-4">
      <a routerLink="seasons" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        [routerLinkActiveOptions]="{exact: true}"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Seasons</a>
      <a routerLink="fields" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Fields</a>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
